import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';

import styles from './styles/Spinner.module.scss';

export const spinnerVariants = cva(styles.spinner, {
  variants: {
    size: {
      s: styles.small,
      m: styles.medium,
      l: styles.large,
    },
    variant: {
      light: styles.light,
      dark: styles.dark,
    },
  },
  defaultVariants: {
    size: 'm',
    variant: 'light',
  },
});

export type SpinnerProps = VariantProps<typeof spinnerVariants>;

const Spinner = ({ className, size, variant }: { className?: string } & SpinnerProps) => {
  return (
    <div
      aria-label="loading"
      className={clsx(spinnerVariants({ size, variant }), className)}
      data-cxy-name="spinner"
      role="status"
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export { Spinner };
